import { AxiosRequestConfig } from "axios";

export const cpvHandleRequest = (config: AxiosRequestConfig) => {
  const token = localStorage.getItem("cpv_token");

  config.headers = {
    ...config.headers,
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  return config;
};

export const cpvHandleErrorRequest = (error: any) =>
  Promise.reject(error);